import produce from 'immer';
import { fulfilled, idle } from 'src/redux/constants';
import {
  CLEAR_TEST,
  SET_CRON_FINISHED,
  SET_CRON_STARTED,
  SET_SHOW_ANSWERS,
  SET_SHOW_POINTS,
  SET_TEST_ALL_DATA,
  SET_TEST_FINAL,
  SET_TEST_ID,
  SET_TEST_NAME,
  SET_TEST_SCORE,
  SET_TEST_TAGS,
  SET_TEST_TYPE,
  SET_TEST_WELCOME,
  SET_TYPE_COUNTER,
} from './constants';
import {
  SetAllData,
  SetShowAnswers,
  SetShowPoints,
  SetCronFinished,
  SetCronStarted,
  SetTestFinal,
  SetTestId,
  SetTestName,
  SetTestScore,
  SetTestTags,
  SetTestType,
  SetTestWelcome,
  SetTypeCounter,
  TestDataActionTypes,
  TestState,
} from './types';

const initialState: TestState = {
  id: null,
  name: '',
  type: 0,
  welcome_page_header: '',
  welcome_page_description: '',
  final_page_header: '',
  final_page_description: '',
  tags: null,
  statusLoads: idle,
  passing_score: 0,
  is_show_answers: false,
  is_show_points: false,
  cron_started_at: null,
  cron_finished_at: null,
  status: null,
  type_counter: 0,
};

export default produce(
  (draft = initialState, action: TestDataActionTypes): TestState => {
    switch (action.type) {
      case SET_TEST_ALL_DATA: {
        const newAction = (action as SetAllData).payload;
        draft.id = newAction.id;
        draft.name = newAction.name;
        draft.type = newAction.type || 0;
        draft.welcome_page_header = newAction.welcome_page_header;
        draft.welcome_page_description = newAction.welcome_page_description;
        draft.final_page_header = newAction.final_page_header;
        draft.final_page_description = newAction.final_page_description;
        draft.tags = newAction.tags;
        draft.passing_score = newAction?.passing_score;
        draft.statusLoads = fulfilled;
        draft.is_show_answers = newAction.is_show_answers;
        draft.is_show_points = newAction.is_show_points;
        draft.cron_started_at = newAction.cron_started_at;
        draft.cron_finished_at = newAction.cron_finished_at;
        draft.type_counter = newAction.type_counter;
        draft.status = newAction.status;
        break;
      }
      case SET_TEST_NAME: {
        draft.name = (action as SetTestName).payload;
        break;
      }
      case SET_TEST_TYPE: {
        draft.type = (action as SetTestType).payload;
        break;
      }
      case SET_TEST_WELCOME: {
        draft.welcome_page_header = (
          action as SetTestWelcome
        ).payload.welcomeTitle;
        draft.welcome_page_description = (
          action as SetTestWelcome
        ).payload.welcomeDescription;
        break;
      }
      case SET_TEST_FINAL: {
        draft.final_page_header = (action as SetTestFinal).payload.finalTitle;
        draft.final_page_description = (
          action as SetTestFinal
        ).payload.finalDescription;
        break;
      }
      case SET_TEST_TAGS: {
        const data = (action as SetTestTags).payload;
        draft.tags = data;
        break;
      }
      case SET_TEST_ID: {
        draft.id = (action as SetTestId).payload;
        break;
      }
      case SET_TEST_SCORE: {
        draft.passing_score = (action as SetTestScore).payload;
        break;
      }
      case CLEAR_TEST: {
        draft = initialState;
        return draft;
      }
      case SET_SHOW_ANSWERS: {
        draft.is_show_answers = (action as SetShowAnswers).payload;
        break;
      }
      case SET_SHOW_POINTS: {
        draft.is_show_points = (action as SetShowPoints).payload;
        break;
      }
      case SET_CRON_STARTED: {
        draft.cron_started_at = (action as SetCronStarted).payload;
        break;
      }
      case SET_CRON_FINISHED: {
        draft.cron_finished_at = (action as SetCronFinished).payload;
        break;
      }
      case SET_TYPE_COUNTER: {
        draft.type_counter = (action as SetTypeCounter).payload;
        break;
      }
      default:
        return draft;
    }
  },
);
